import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    }),
    header: css({
        marginTop: '18px',
        position: 'relative',
        marginBottom: '20px',
    }),

    headerStripe: !isHosTheme
        ? css({
              '::before': {
                  content: '""',
                  position: 'absolute',
                  top: '-18px',
                  left: 0,
                  width: '70px',
                  height: '6px',
                  background: theme.palette.primary.main,
              },
          })
        : 'none',
};
